import React from 'react';
import classnames from 'classnames';
import s from './ProgressBar.scss';
class ProgressBar extends React.Component {
    render() {
        const { color, background, percentage, className, barClassName, children, 'aria-label': ariaLabel } = this.props;
        const limitedPercentage = Math.min(percentage, 100);
        return /*#__PURE__*/ React.createElement("div", {
            "aria-label": ariaLabel,
            role: "progressbar",
            "aria-valuenow": Math.floor(limitedPercentage),
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            className: classnames(s['root'], className),
            style: {
                background
            }
        }, children, /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['bar'], s['animated'], barClassName),
            style: {
                background: color,
                transform: `scaleX(${limitedPercentage / 100})`,
                transformOrigin: 'left center'
            },
            "aria-hidden": "true"
        }));
    }
}
export default ProgressBar;
